import { render, staticRenderFns } from "./MyDate.vue?vue&type=template&id=2ac80a4f&scoped=true&"
import script from "./MyDate.vue?vue&type=script&lang=js&"
export * from "./MyDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac80a4f",
  null
  
)

export default component.exports